import { AjsCatalogsService } from "./catalogs.service.js";
import { ArtestTopBarCatalogButtonComponent } from "./components/artest-top-bar-catalog-button.component.js";
import { AjsCatalogEditorModalComponent } from "./components/catalog-editor-modal.component.js";
import { AjsCatalogItemViewerModalComponent } from "./components/catalog-item-viewer.component.js";
import { AjsCatalogViewerModalComponent } from "./components/catalog-viewer-modal.component.js";

export const ajsCatalogsModule = "catalogs.feature.gameApp"; 

angular.module( ajsCatalogsModule, [ ])

.service( AjsCatalogsService.name, AjsCatalogsService )

.component( AjsCatalogViewerModalComponent.name, AjsCatalogViewerModalComponent )
.component( AjsCatalogEditorModalComponent.name, AjsCatalogEditorModalComponent )
.component( AjsCatalogItemViewerModalComponent.name, AjsCatalogItemViewerModalComponent )

.component( ArtestTopBarCatalogButtonComponent.name, ArtestTopBarCatalogButtonComponent.asAjsComponent() ) 

.run([ "$rootScope", "$compile", "catalogsService", "gameSceneService", function( $rootScope, $compile, catalogsService, gameService ) {


    gameService.$ready.then(() => {

        let element = $( `<li><a><${ ArtestTopBarCatalogButtonComponent.selector }></${ ArtestTopBarCatalogButtonComponent.selector }></a></li>` );

        let target = $("#artestUserBar ul.leftie-btn-wrapper");

        target.append( $compile( element )( $rootScope ) );
    });
}])